<template>
	<button @click="request" :class="classes"><slot /></button>
</template>

<script>
export default {
	props: {
		classes: {
			type: String,
		},
		expert: {
			type: String,
		},
		userEmail: {
			type: String,
		},
	},
	methods: {
		request: function () {
			const data = {
				fields: [
					{
						name: 'email',
						value: this.userEmail,
					},
					{
						name: 'matchmaker_match',
						value: this.expert,
					},
				],
			}

			this.$emit('user-requested', data)
		},
	},
}
</script>
